<div class="container-fluid tp-box bos-host" [@flipState]="flip">

	<div class="row tp-box__side tp-box__back" *ngIf="flip === 'active'">
		<div class="cw-wrap bos-wrap" [ngStyle]="themeVars">
			<div class="cw-icon-badge pointer" (click)="toggleFlip()" title="Back">
				<i class="material-icons">arrow_back</i>
			</div>
			<div class="cw-header">
				<div class="cw-title-group">
					<span class="cw-title">{{ title }}</span>
				</div>
			</div>
			<div class="cw-body">

				<div class="d-flex flex-wrap align-items-center mb-3 gap-2">
					<div class="btn-group btn-group-sm mr-3">
						<button class="btn" [ngClass]="showAll ? 'btn-dark' : 'btn-outline-secondary'" (click)="setFilter('all')">
							All <span class="badge badge-light ml-1">{{ allData.length }}</span>
						</button>
						<button class="btn" [ngClass]="showFillable ? 'btn-success' : 'btn-outline-success'" (click)="setFilter('fillable')">
							<i class="material-icons" style="font-size:14px;vertical-align:middle">check_circle</i>
							Fillable <span class="badge badge-light ml-1">{{ fillableCount }}</span>
						</button>
						<button class="btn" [ngClass]="showShort ? 'btn-danger' : 'btn-outline-danger'" (click)="setFilter('short')">
							<i class="material-icons" style="font-size:14px;vertical-align:middle">error</i>
							Short <span class="badge badge-light ml-1">{{ shortCount }}</span>
						</button>
					</div>

					<mat-form-field appearance="outline" class="mr-auto" style="max-width:280px;">
						<mat-label>Search orders, items, customers…</mat-label>
						<input matInput (keyup)="applyFilter($event)" placeholder="e.g. KMC19570">
						<mat-icon matSuffix>search</mat-icon>
					</mat-form-field>

					<button class="btn btn-sm btn-success ml-2" (click)="exportXls()" [disabled]="exporting || dataSource.data.length === 0">
						<i class="fa fa-file-excel-o"></i> XLS
					</button>
					<button class="btn btn-sm btn-danger ml-2" (click)="exportPdf()" [disabled]="exporting || dataSource.data.length === 0">
						<i class="fa fa-file-pdf-o"></i> PDF
					</button>
				</div>

				<div class="table-responsive bos-table-wrap" #print_table>
					<table mat-table [dataSource]="dataSource" matSort class="table table-sm table-hover w-100">

						<ng-container matColumnDef="ORDERNO">
							<th mat-header-cell *matHeaderCellDef mat-sort-header>Order #</th>
							<td mat-cell *matCellDef="let r">
								<a class="pointer text-primary font-weight-bold" (click)="goToOrder(r.ORDERNO)">{{ r.ORDERNO }}</a>
							</td>
						</ng-container>

						<ng-container matColumnDef="DATE">
							<th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
							<td mat-cell *matCellDef="let r">{{ r.DATE | date:'MMM d' }}</td>
						</ng-container>

						<ng-container matColumnDef="CUSTOMER">
							<th mat-header-cell *matHeaderCellDef mat-sort-header>Customer</th>
							<td mat-cell *matCellDef="let r">
								<div class="font-weight-bold">{{ r.NAME }}</div>
								<small class="text-muted">{{ r.CUSTOMER }}</small>
							</td>
						</ng-container>

						<ng-container matColumnDef="SALESPERSON">
							<th mat-header-cell *matHeaderCellDef mat-sort-header>Rep</th>
							<td mat-cell *matCellDef="let r">{{ r.SALESPERSON }}</td>
						</ng-container>

						<ng-container matColumnDef="ITEMCODE">
							<th mat-header-cell *matHeaderCellDef mat-sort-header>Item</th>
							<td mat-cell *matCellDef="let r">
								<a class="pointer text-primary" (click)="goToItem(r.ITEMCODE)">{{ r.ITEMCODE }}</a>
							</td>
						</ng-container>

						<ng-container matColumnDef="DESCRIPTION">
							<th mat-header-cell *matHeaderCellDef mat-sort-header>Description</th>
							<td mat-cell *matCellDef="let r">{{ r.DESCRIPTION }}</td>
						</ng-container>

						<ng-container matColumnDef="OUTSTANDING">
							<th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">On Order</th>
							<td mat-cell *matCellDef="let r" class="text-center font-weight-bold">{{ r.OUTSTANDING }}</td>
						</ng-container>

						<ng-container matColumnDef="QOH">
							<th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">In Stock</th>
							<td mat-cell *matCellDef="let r" class="text-center">
								<span class="badge"
									[ngClass]="{
										'badge-success':  +r.QOH >= +r.OUTSTANDING,
										'badge-warning':  +r.QOH > 0 && +r.QOH < +r.OUTSTANDING,
										'badge-danger':   +r.QOH <= 0
									}">
									{{ r.QOH }}
								</span>
							</td>
						</ng-container>

						<ng-container matColumnDef="NETTOTAL">
							<th mat-header-cell *matHeaderCellDef mat-sort-header class="text-right">Total</th>
							<td mat-cell *matCellDef="let r" class="text-right">{{ r.NETTOTAL | currency }}</td>
						</ng-container>

						<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
						<tr mat-row *matRowDef="let r; columns: displayedColumns;" [ngClass]="rowClass(r)"></tr>

						<tr class="mat-row" *matNoDataRow>
							<td class="mat-cell text-center text-muted py-4" [attr.colspan]="displayedColumns.length">
								No back orders match the current filter.
							</td>
						</tr>
					</table>
				</div>

				<mat-paginator [pageSizeOptions]="[25, 50, 100, 250]" pageSize="50" showFirstLastButtons></mat-paginator>
			</div>
		</div>
	</div>

	<div class="row tp-box__side tp-box__front" [ngClass]="flip === 'inactive' ? '' : 'd-none'">
		<div class="col-12 p-0">
			<app-dashboard-stat-card
				title="Back Orders vs Stock"
				icon="inventory_2"
				accent="rose"
				[value]="totalOrders"
				[loading]="loading"
				[buckets]="summaryBuckets"
				[showView]="!loading && totalOrders > 0"
				(view)="toggleFlip()"
				(bucketView)="onSummaryBucket($event)">
			</app-dashboard-stat-card>
		</div>
	</div>

</div>
